<template>
    <div class="ui-xselect flex flex-col ">
        <div class="content font-s flex flex-center-cz padding-left-m padding-right-m flex-space-between scroll "
             ref="content">
            <div class="selected flex flex-wrap padding-bottom-s ">
                <div class="item margin-right-m margin-top-s padding-left-s padding-right-s flex flex-center-cz"
                     v-for="item in selectData">
                    <div>{{item.text}}</div>
                    <img @click="close(item.value)" class="logo-18 pointer" src="@/assets/images/guanbi.png"/>
                </div>
            </div>
            <div @click="select" class="box-down margin-top-s pointer"></div>
        </div>
        <div @click="listClick" class="position-relative flex " v-if="show">
            <div :style="{left:leftValue,top:topValue,width:listWidth+'px'}" class="list flex flex-col font-s scroll">
                <div class="item cannotselect" v-for="item in data">
                    <input :disabled="disabled" :value="item.value" @change="inputChange" type="checkbox" v-model="checks">{{item.text}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "XSelect",
        props: {
            data: {},
            values: {},
            disabled: false
        },
        model: {
            prop: "values",
            event: "change"
        },
        watch: {
            values: {
                handler(newValue) {
                    if (newValue == null) {
                        this.checks = [];
                    } else {
                        if (!Array.isArray(newValue)) {
                            this.checks = JSON.parse(newValue);
                        } else {
                            this.checks = newValue;
                        }
                    }
                    this.selectData = [];
                    if (this.checks  != null ) {
                        this.checks.forEach(item => {
                            if (this.data !== null && this.data !== "") {
                              let find = this.data.filter(b => b.value == item);
                              if (find.length > 0) {
                                this.selectData.push(find[0]);
                              }
                            }
                        });
                    }
                },
                immediate: true,
                deep: true   //深度监听
            }
        },
        data() {
            return {
                checks: [],
                selectData: [],
                show: false,
                leftValue: '',
                topValue: '',
                listWidth: '',
            }
        },
        methods: {
            close(value) {
                if(this.disabled){
                    return
                }
                this.selectData = this.selectData.filter(item => item.value != value);//数组过滤得到一个匹配的一个新数组
                this.checks = this.checks.filter(item => item != value);//数组过滤得到一个匹配的一个新数组
                this.$emit("change", this.checks);//触发父组件 change事件
            },
            inputChange() {
                console.log("change", this.checks)
                this.selectData = [];
                if (this.checks != null) {
                    this.checks.forEach(item => {
                        let find = this.data.filter(b => b.value == item);//数组过滤得到一个匹配的一个新数组
                        if (find.length > 0) {
                            this.selectData.push(find[0]);//往数组中添加一项
                        }
                    });
                }
                this.$emit("change", this.checks);//子组件向父组件传值
            },
            listClick(event) {
                event.stopPropagation();//阻止冒泡，防止触发下层点击事件
            },
            select(event) {
                event.stopPropagation();//阻止冒泡，防止触发下层点击事件
                document.addEventListener("click", this.closeList, false);// 添加监听点击事件

                let tValue = this.$el.getBoundingClientRect().top;
                let lValue = this.$el.getBoundingClientRect().left;
                let windowHeight = document.documentElement.clientHeight; // 实时屏幕高度

                let inputHeight = this.$refs['content'].clientHeight;
                this.listWidth = this.$refs['content'].clientWidth;

                console.log("listWidth", this.listWidth);

                let listHeight = 200;
                this.topValue = tValue + inputHeight + 'px';
                this.leftValue = lValue + 'px';
                if (parseFloat(tValue) + listHeight > windowHeight) {
                    this.topValue = (parseFloat(windowHeight) - listHeight - inputHeight) + "px";
                    console.log("tvalue1", this.tValue)
                }
                this.show = !this.show;
            },
            closeList() {
                document.removeEventListener("click", this.closeList, false);//关闭监听点击事件
                this.show = false;
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/xSelect/XSelect.vue